export default "__VITE_PUBLIC_ASSET__262cb647__"